import React from 'react'
import { ChevronDown } from 'react-feather'

interface AccordianProps {
  label: string,
  display: boolean,
  onChange: () => void
}

const DisplayAccordianHeader: React.FC<AccordianProps> = ({label, display, onChange}) => {
  return(
    <button
      onClick={onChange}
      className='w-full group bg-dark-card border border-dark-border rounded-xl flex flex-row items-center justify-between px-6 py-4 mt-3 transition-all duration-200 hover:shadow-lg hover:border-accent-teal/30 cursor-pointer'
    >
      <div className='flex items-center gap-3'>
        <div className={`w-1 h-8 rounded-full transition-all duration-200 ${display ? 'bg-accent-teal' : 'bg-dark-border'}`} />
        <h2 className='text-white font-semibold text-xl tracking-tight'>{label}</h2>
      </div>
      <div className={`transition-transform duration-200 ${display ? 'rotate-180' : 'rotate-0'}`}>
        <ChevronDown
          height={24}
          width={24}
          className='text-gray-400 group-hover:text-accent-teal transition-colors duration-200'
        />
      </div>
    </button>
  )
}

export default DisplayAccordianHeader
